import {isMSDKV5,getParamsByKey} from "@/utils/msdkEnv.js"
// 如需切换开发环境或测试环境的全局接口环境修改devEnv,如切换为'development'将调用测试环境接口
const devEnv = 'production'; // 'development' | 'production'

export const env = process.env.TYPE === 'prod' ? 'production' : devEnv;

export const sandboxObj = env === 'production' ? {} : { sandbox: 1 };

export const timeout = 3 * 1000;
export const loginType = isMSDKV5() ? {login_type: 'msdkv5',gameid_v5: getParamsByKey('gameid')} : {login_type: 'msdk',gameid: getParamsByKey('gameid')}
export const game = 'gp';

export const bid = 'ingame';

// V4业务号
export const v4ServiceId = 182;

export const ingameBaseUrl = 'https://app.ingame.qq.com';
export const ingameTestBaseUrl = 'https://appt.ingame.qq.com';

export const gicpBaseUrl = 'https://apps.game.qq.com';
// export const gicpTestBaseUrl = 'https://go.gicp.game.qq.com';
export const gicpTestBaseUrl = 'https://apps.game.qq.com';

export const gzhBaseUrl = 'https://gw.gzh.qq.com';
export const gzhTestBaseUrl = 'https://gw.gzh.qq.com';
